var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"stack",staticClass:"platform-banners"},[_c('SeatsExceededBanner'),_c('PlatformAlertBanner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }